import { Routes } from '../api-routes'

export type PathId =
  | 'alertId'
  | 'beneficiaryId'
  | 'asCaseWorkerId'
  | 'caseWorkerId'
  | 'chatSessionId'
  | 'documentId'
  | 'organizationId'
  | 'processFilePromptTemplateType'
  | 'promptTemplateId'
  | 'promptTemplateType'
  | 'resourceId'
  | 'taskId'
  | 'userId'
type P = Partial<Record<PathId, string>>

/**
 * Build a path (string) from an object properties.
 *
 * @param object - The object to build the path from.
 * @param endOfPath - (optional) The end of the path.
 * @returns The path as a string or throw an error if the  is not an object.
 */
export const getPath = (object: P, options?: { suffix?: string; prefix?: string }) => {
  if (typeof object !== 'object')
    throw new Error(
      `Invalid payload in pathBuilder, expected object and got ${typeof object} instead. The given parameter is: ${object}`,
    )

  let path = ''

  if (options?.prefix) path += '/' + options.prefix

  if ('organizationId' in object) path += `/${Routes.Organizations}/${object.organizationId}`

  if ('beneficiaryId' in object) path += `/${Routes.Beneficiaries}/${object.beneficiaryId}`

  if ('caseWorkerId' in object) path += `/${Routes.CaseWorkers}/${object.caseWorkerId}`

  if ('asCaseWorkerId' in object) path += `/${Routes.CaseWorkers}/${object.asCaseWorkerId}`

  if ('resourceId' in object) path += `/${Routes.Resources}/${object.resourceId}`

  if ('promptTemplateType' in object) path += `/${Routes.PromptTemplates}/${object.promptTemplateType}`

  if ('promptTemplateId' in object) path += `/${object.promptTemplateId}`

  if ('alertId' in object) path += `/${Routes.Alerts}/${object.alertId}`

  if ('documentId' in object) path += `/${Routes.Documents}/${object.documentId}`

  if ('userId' in object) path += `/${Routes.Users}/${object.userId}`

  if ('taskId' in object) path += `/${Routes.Tasks}/${object.taskId}`

  if ('chatSessionId' in object) path += `/${Routes.ChatSessions}/${object.chatSessionId}`

  if ('processFilePromptTemplateType' in object) path += `/${Routes.File}/${object.processFilePromptTemplateType}`

  if (options?.suffix) path += '/' + options.suffix

  return path
}

export const setP = (values: PathId[]): P => {
  const defaults: P = {}
  values.forEach((v) => {
    if (v === 'organizationId') defaults.organizationId = ':organizationId'
    if (v === 'beneficiaryId') defaults.beneficiaryId = ':beneficiaryId'
    if (v === 'caseWorkerId') defaults.caseWorkerId = ':caseWorkerId'
    if (v === 'asCaseWorkerId') defaults.caseWorkerId = ':asCaseWorkerId'
    if (v === 'resourceId') defaults.resourceId = ':resourceId'
    if (v === 'promptTemplateType') defaults.promptTemplateType = ':promptTemplateType'
    if (v === 'promptTemplateId') defaults.promptTemplateId = ':promptTemplateId'
    if (v === 'alertId') defaults.alertId = ':alertId'
    if (v === 'documentId') defaults.documentId = ':documentId'
    if (v === 'userId') defaults.userId = ':userId'
    if (v === 'taskId') defaults.taskId = ':taskId'
    if (v === 'chatSessionId') defaults.chatSessionId = ':chatSessionId'
    if (v === 'processFilePromptTemplateType') defaults.processFilePromptTemplateType = ':processFilePromptTemplateType'
  })
  return defaults
}
